import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { trackEvent } from 'dibs-tracking';

// components
import { FormattedMessage } from 'react-intl';
import { ExpandingAreaWithReadMore } from 'dibs-elements/exports/ExpandingArea';
import { PdpSharedStorytellingTrackingWrapper } from '../PdpSharedStorytellingComponents/PdpSharedStorytellingTracking';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

function getRoleString(role) {
    if (!role) {
        return '';
    }
    const [firstLetter] = role;
    const restOfLetters = role.substring(1);
    return `(${firstLetter.toUpperCase()}${restOfLetters.toLowerCase()})`;
}

export const Title = ({ name, role }) => (
    <PdpSharedStorytellingTrackingWrapper>
        <FormattedMessage
            id="PdpSharedDescriptionAboutCreator.creatorTitle"
            defaultMessage="About {name} {role}"
            values={{ name, role: getRoleString(role) }}
        />
    </PdpSharedStorytellingTrackingWrapper>
);
Title.propTypes = {
    name: PropTypes.string,
    role: PropTypes.string,
};
export const Content = ({ contentClass, description }) => {
    return (
        <ExpandingAreaWithReadMore
            collapsedHeight={72}
            onReadMoreClick={({ type }) => {
                if (type === 'readMore') {
                    trackEvent({
                        category: 'promo interaction',
                        action: 'about the creator continue reading clicked',
                        label: 'pdp',
                    });
                }
            }}
        >
            <span
                className={classNames(styles.creatorContent, contentClass)}
                dangerouslySetInnerHTML={{ __html: description }}
            />
        </ExpandingAreaWithReadMore>
    );
};
Content.propTypes = {
    contentClass: PropTypes.string,
    description: PropTypes.string,
};

function PdpSharedDescriptionAboutCreatorComponent(props) {
    const { headerClass, contentClass, item } = props;
    const { role, name, description, sellerId } = get(item, 'creatorContent') || {};

    // GROWTH-5724 If creator bio is provided by seller do not show the bio on PDP
    if (!name || !description || sellerId) {
        return null;
    }

    return (
        <div data-tn="pdp-item-description-about-creator" className={styles.wrapper}>
            <h2 className={classNames(styles.header, headerClass)}>
                <Title name={name} role={role} />
            </h2>
            <Content contentClass={contentClass} description={description} />
        </div>
    );
}

PdpSharedDescriptionAboutCreatorComponent.propTypes = {
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export const PdpSharedDescriptionAboutCreator = createFragmentContainer(
    PdpSharedDescriptionAboutCreatorComponent,
    {
        item: graphql`
            fragment PdpSharedDescriptionAboutCreator_item on Item {
                creatorContent {
                    name
                    description
                    role
                    sellerId
                }
            }
        `,
    }
);
